export const NFTContractAddress = "0xA6d0eea3AfaB2696a840731537874e058BC8049f";
export const RoyaltyPoolContractAddress = "0xEc331cbD4FCF8F2983A4aE9293fB513Ea2b0400c";
export const projectChainId = "0x1";
export const ImageBaseURI_Metadata = "https://ipfs.io/ipfs/";
export const ImageBaseURI_Display = "https://scalesnft.mypinata.cloud/ipfs/";